import styles from "../SuccessPlan.module.scss";
import { Typography } from "@mui/material";

const SubSectionTitle = ({ title }: { title: string }) => {
  return (
    <div style={{ display: "flex", gap: "8px" }}>
      <div
        style={{
          width: "4px",
          backgroundColor: "#00A0D1",
          borderRadius: "0 4px 4px 0",
        }}
      ></div>
      <Typography className={styles["sp-subtitle"]}>{title}</Typography>
    </div>
  );
};
export default SubSectionTitle;
